import type { ComponentProps } from 'react';
import React from 'react';

import { useTrackEffect } from '@order/Telemetry';

import { SignedOutView } from '../../SignedOutView';

export const AccountSignedOutMessage = (
  props: ComponentProps<typeof SignedOutView>,
) => {
  useTrackEffect('account.logged_out_view');

  return <SignedOutView {...props} />;
};
